/** Frosted panel — see `.glass` in index.css */
export const glass = "glass";
export const glassCard = "glass flex flex-col p-4 sm:p-6 lg:p-8";
